<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="customerOrders.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/sales/customer-orders/view/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="customerOrder"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :customer-order="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="customerOrders.per_page"
        layout="total, prev, pager, next"
        :total="customerOrders.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Actions from './Actions';
import TableSettings from '../../TableSettings';
import columns, { allColumns, labels, compareTypes } from './columns';

export default {
  components: {
    Actions,
    TableSettings,
    ...columns,
  },
  data() {
    return {
      labels,
      allColumns,
      tableKey: 0,
      currentPage: 1,
      currentSort: {
        prop: 'created_at',
        order: 'descending',
      },
    };
  },
  computed: {
    customerOrders() {
      return this.$store.getters['customerOrder/customerOrders'];
    },
    tableConfig() {
      return JSON.parse(JSON.stringify(this.$store.getters['customerOrder/tableConfig']));
    },
    loading() {
      return this.$store.getters['customerOrder/loading'];
    },
  },
  watch: {
    tableConfig() {
      this.tableKey++;
    },
  },
  async mounted() {
    this.$store.commit('customerOrder/setFilterString', '');
    this.$store.commit('customerOrder/setCurrentPage', this.currentPage);
    this.$store.commit('customerOrder/setSorting', this.currentSort);
    await this.$store.dispatch('customerOrder/fetchAll');
  },
  methods: {
    handleCurrentChange(val) {
      this.$store.commit('customerOrder/setCurrentPage', val);
      this.$store.dispatch('customerOrder/fetchAll');
    },
    handleSortChange({ column, prop, order }) {
      if (column.sortable === 'custom') {
        this.$store.commit('customerOrder/setSorting', { prop, order, compareType: compareTypes[prop] || 'string' });
        this.$store.dispatch('customerOrder/fetchAll');
      }
    },
  },
};
</script>
<style>
  .pointer-row {
    cursor: pointer;
  }
</style>
